import { POOL_ONE, POOL_THREE, POOL_TWO } from "common/utils/readable/ReadableIdsData";
import { random } from "lodash/fp";

const getRandomItemFromPool = (pool: string[]) => pool[random(0, pool.length - 1)];

export const generateHumanReadableId = () => [POOL_ONE, POOL_TWO, POOL_THREE].map(getRandomItemFromPool).join(" ");
